import { useSupportsWebp as useDetectWebp } from '@folklore/hooks';
import { createContext, ReactNode, use } from 'react';

const defaultSupportsWebp = true;

interface DeviceContextValue {
    supportsWebp: boolean;
}

export const DeviceContext = createContext<DeviceContextValue>({
    supportsWebp: defaultSupportsWebp,
});

export function useDeviceContext() {
    const context = use(DeviceContext);
    return context;
}

export function useSupportsWebp() {
    const { supportsWebp } = useDeviceContext();
    return supportsWebp;
}

interface DeviceContextProviderProps {
    supportsWebp?: boolean | null;
    children?: ReactNode;
}

export function DeviceContextProvider({
    supportsWebp: initialSupportsWebp = defaultSupportsWebp,
    children = null,
}: DeviceContextProviderProps) {
    const supportsWebp = useDetectWebp(initialSupportsWebp);
    const value = {
        supportsWebp,
    };

    return <DeviceContext value={value}>{children}</DeviceContext>;
}
